import { APPEARANCES as BACKGROUND_APPEARANCES } from '../../../constants';
import { APPEARANCES as TEXT_APPEARANCES } from '../../../../text/constants';

const getTextAppearances = (title, appearance) => {
  let titleAppearance;
  let descriptionAppearance;
  let hotkeyAppearance;

  if (appearance === BACKGROUND_APPEARANCES.light) {
    titleAppearance = TEXT_APPEARANCES.highEmphasis;
    hotkeyAppearance = TEXT_APPEARANCES.mediumEmphasis;
    descriptionAppearance = title ? TEXT_APPEARANCES.mediumEmphasis : TEXT_APPEARANCES.highEmphasis;
  }

  if (appearance === BACKGROUND_APPEARANCES.dark) {
    titleAppearance = TEXT_APPEARANCES.white;
    descriptionAppearance = title ? TEXT_APPEARANCES.lowEmphasis : TEXT_APPEARANCES.white;
    hotkeyAppearance = TEXT_APPEARANCES.lowEmphasis;
  }

  return {
    titleAppearance,
    descriptionAppearance,
    hotkeyAppearance,
  };
};

export default getTextAppearances;
